import { useQuery } from "@tanstack/react-query";
import { getFunctions } from "../../../services/rules";
import { functionsQueryKey } from "./queryKeys";

// Fetches the catalog of field functions (SUM, AVG, COUNT, custom, etc.). Pure
// server cache, no scope, so no React Context needed.
export function useFunctionsQuery() {
  return useQuery({
    queryKey: functionsQueryKey(),
    queryFn: getFunctions,
    refetchOnWindowFocus: false,
    retry: 1,
  });
}
